<template>
    <div class="auto-complete" :class="{loading: loading}">
        <div class="has-feedback">
            <label :for="name" class="relative display-block">
                {{label}} <i v-if="tooltipText !== null" class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">{{ tooltipText }}</span></i>

                <button type="button" class="btn btn-xs btn-warning pull-right"
                        v-if="model"
                        @click="setModel(null)">
                    Remove {{label}}
                </button>
            </label>

            <input class="search-input form-control"
                   v-model="search"
                   @focus="setSearchFocus(true)"
                   :disabled="model_id">

            <input class="form-control active-hidden"
                   type="text"
                   v-model="model_id"
                   :name="name"
                   :required="required"
                   :aria-required="required">
        </div>

        <div class="search-results" v-if="showResults">
            <div v-if="scrollable" style="max-height: 400px; overflow-y: auto">
                <div class="model" v-for="currentModel in models" v-on:click="setModel( currentModel )">
                    <slot v-bind="currentModel" name="model-display">
                        {{currentModel}}
                    </slot>
                </div>
            </div>
            <div v-else>
                <div class="model" v-for="currentModel in models" v-on:click="setModel( currentModel )">
                    <slot v-bind="currentModel" name="model-display">
                        {{currentModel}}
                    </slot>
                </div>
            </div>

            <div class="no-results" v-if="models && models.length === 0">
                <h5>No Results Found</h5>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'Search'
            },
            tooltipText: {
                type: [String, null],
                default: null
            },
            name: {
                type: String,
                required: true
            },
            required: {
                type: Boolean,
                default: false
            },
            resourceUrl: {
                type: String,
                required: true
            },
            queryString: {
                type: String,
                default: ''
            },
            initialId: {
                type: String,
                default: null
            },
            findResultIndex: {
                type: String,
                default: null
            },
            searchResultsIndex: {
                type: String,
                default: null
            },
            limit: {
                type: String,
                default: '20'
            },
            scrollable: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                loading: true,
                loadingModels: false,
                models: [],
                oldModel: null,
                model: null,
                search: null,
                searchFocus: false,
            }
        },

        mounted(){
            this.init();
        },

        computed: {
            showResults(){
                return (typeof this.search) === 'string' && this.search.length >= 1 && this.searchFocus;
            },
            model_id(){
                return _.get( this.model, 'id' );
            }
        },
        watch: {
            search: _.debounce( function(){
                this.loadingModels = true;

                this.loadModels()
                    .then( () => {
                        this.loadingModels = false;
                    } )
            }, 380, {
                trailing: true
            } ),

            model( model ){
                // Reset the validator instance when setting the model
                var form = $( this.$el ).parents( 'form._validate:first' );

                if( form.length ){
                    var validator = form.data( 'validator' );

                    if( validator ){
                        validator.resetForm();
                    }
                }

                // Set the search text from the model-display slot
                if( model ){
                    this.search = this.getModelDisplayText( model );
                }
                else {
                    this.search = null;
                }
            },

            model_id(){
                this.$emit( 'change', this.model_id, this.model );
            },

            initialId(){
                this.loadModel();
            }
        },
        methods: {
            init(){
                this.loadModel()
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err );
                    } )
                    .finally( ( resident ) => {
                        this.loading = false;
                    } );
            },

            getModelDisplayText( model ){
                var displayText = this.$scopedSlots[ 'model-display' ]( model )[ 0 ].text;

                if( typeof displayText === 'string' ){
                    return displayText.trim();
                }
            },

            setModel( model ){
                this.model = model;
                this.searchFocus = false;
            },

            loadModel(){
                if( !this.initialId ){
                    return Promise.resolve( null );
                }

                return axios.get( this.resourceUrl + '/' + this.initialId )
                    .then( ( response ) => {
                        if( this.findResultIndex ){
                            this.setModel( _.get( response.data, this.findResultIndex ) );
                        }
                        else {
                            this.setModel( response.data );
                        }
                    } );
            },

            loadModels(){
                var url = this.resourceUrl;
                if( !url.includes( '?' ) ){
                    url += '/?';
                }

                url += `&limit=${this.limit}`;

                if( this.queryString ){
                    url += '&' + this.queryString;
                }

                if( this.showResults ){
                    url += '&q=' + this.search;
                }

                return axios.get( url )
                    .then( ( response ) => {
                        if( this.searchResultsIndex ){
                            if( !_.has( response.data, this.searchResultsIndex ) ){
                                console.error( 'Unrecognized searchResultsIndex' );
                            }

                            this.models = _.get( response.data, this.searchResultsIndex );
                        }
                        else {
                            this.models = response.data;
                        }
                    } );
            },

            setSearchFocus( value ){
                this.searchFocus = value;
            },

            reset(){
                Object.assign( this.$data, this.$options.data() );

                this.init();
            }
        }
    }
</script>
